import React from 'react'
import Header from './micrositeHeader'
import { Link } from 'gatsby'
import styled from '@emotion/styled'
import tw from 'tailwind.macro'
import defaultBannerImage from '../../images/page-header-banner-strip.png'
import { GatsbyImage } from 'gatsby-plugin-image'
import '../../styles/layout.css'

const Layout = (props) => {
  const { showNav, onHideNav, onShowNav, mainBannerImage } = props
  const siteUrl = props.slug.current

  // styles components
  const RootDiv = tw.div`
 flex flex-col min-h-screen items-center
 `
  // const FullWidthContainer = tw.div`
  //  w-full flex flex-col items-center px-full
  //  `
  const PageWidthContainer = tw.div`
text-black max-w-7xl w-full font-display px-4
`
  const PageArticle = tw.article`
w-full flex flex-col items-center px-full 
`
  const HeroBannerWrapper = tw.div`
  flex flex-col pt-4
`
  const Footer = tw.footer`
  bg-white mb-6
  text-center sm:flex sm:justify-between text-sm 
`
  const HeroBannerTextWrapper = styled.div`
    ${tw`flex flex-col items-center w-full py-12 bg-black px-full`};
    background-image: url(${defaultBannerImage});
    background-repeat: repeat;
    min-width: 175px;
    min-height: 200px;
  `
  const HeroBannerTextTitle = tw.h1`
  text-white text-left pb-4 leading-tight
`
  const HeroBannerTextSubTitle = tw.p`
  text-white text-left text-xl leading-normal pb-2
`
  const FooterParagraph = tw.p`
  text-black pb-2
`
  const FooterLink = styled(Link)`
    ${tw`text-black hover:text-hr-red`};
    transition: all 0.3s ease-in-out;
  `
  const FooterSeparator = tw.span`
  px-2
`
  return (
    <RootDiv>
      <PageWidthContainer>
        <Header {...props} onHideNav={onHideNav} onShowNav={onShowNav} showNav={showNav} />
      </PageWidthContainer>


      {mainBannerImage && mainBannerImage.asset && mainBannerImage.asset.gatsbyImageData ? (
        <PageArticle>
          <PageWidthContainer>
            <HeroBannerWrapper id="hero_banner">
              <GatsbyImage
                image={mainBannerImage?.asset?.gatsbyImageData}
                alt={mainBannerImage?.alt}
              />
            </HeroBannerWrapper>
          </PageWidthContainer>

          {props.children}
        </PageArticle>
      ) : (
        <PageArticle>
          <HeroBannerTextWrapper>
            <PageWidthContainer>
              <HeroBannerTextTitle>
                {props.text_banner_title ? props.text_banner_title : props.title}
              </HeroBannerTextTitle>
              {props.text_banner_secondary && (
                <HeroBannerTextSubTitle>{props.text_banner_secondary}</HeroBannerTextSubTitle>
              )}
            </PageWidthContainer>
          </HeroBannerTextWrapper>

          {props.children}
        </PageArticle>
      )}

      <PageWidthContainer>
        <Footer className="mt-8">
          <FooterParagraph>
            {props.about_us && (
              <FooterLink
                to={
                  props.nav_options &&
                  props.nav_options.standalonePages &&
                  props.nav_options.standalonePages.includes('about_us')
                    ? `/${siteUrl}/about`
                    : `/${siteUrl}/#about`
                }
              >
                About HireRight
              </FooterLink>
            )}
            {props.about_us && props.contact_us && <FooterSeparator>|</FooterSeparator>}
            {props.contact_us && (
              <FooterLink
                to={
                  props.nav_options &&
                  props.nav_options.standalonePages &&
                  props.nav_options.standalonePages.includes('contact_us')
                    ? `/${siteUrl}/contact`
                    : `/${siteUrl}/#contact`
                }
              >
                Contact Us
              </FooterLink>
            )}
          </FooterParagraph>
          <FooterParagraph>
            Copyright © {new Date().getFullYear()} HireRight, LLC. All Rights Reserved.
          </FooterParagraph>
        </Footer>
      </PageWidthContainer>
    </RootDiv>
  )
}

export default Layout
